export default Object.freeze({
  DOI_MATCH: 'DOI_MATCH',
  HIGHLY_LIKELY: 'HIGHLY_LIKELY',
  USER: 'USER',
  POTENTIAL: 'POTENTIAL',
});
